/**
 * Chemins de l'ecran « Familles et partages » (BO-17, maquette P07).
 *
 * Module **pur**, importe par l'ecran, `App.tsx` et le registre de navigation
 * (`src/ui/navigation.ts`). L'ecran est une liste + un detail (`MasterDetail`) :
 * une seule route `<base>/*` le monte, et le profil ouvert (`<base>/<babyId>`)
 * vit dans l'URL. Le registre pointe la **base**, la route de `App.tsx` porte
 * le `/*`.
 */

export const FAMILIES_PATH = '/families';

export const FAMILIES_ROUTE = `${FAMILIES_PATH}/*`;
